/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Divider, Typography2 } from '@coursera/cds-core';
import type { IconProps } from '@coursera/cds-core';
import type { ButtonName } from '@coursera/event-pulse-types';
import { Link } from '@coursera/event-pulse/react';

import { useEnterpriseAdminTrackingData } from 'bundles/enterprise-admin-hooks/hooks/useEnterpriseAdminTrackingData';

const styles = {
  icon: () => css`
    margin-right: var(--cds-spacing-200);
  `,
  innerWrapper: () => css`
    margin: var(--cds-spacing-300) 0;
    display: flex;
    flex-direction: row;
  `,
  descriptionText: () => css`
    margin-bottom: var(--cds-spacing-50);
  `,
};

type Props = {
  icon: React.ComponentType<IconProps>;
  title: string;
  description: string;
  link: string;
  linkText: string;
  trackingName: ButtonName;
};

const EmptyTrendingSkillsRow = ({ icon, title, description, link, linkText, trackingName }: Props) => {
  const Icon = icon;
  const enterpriseAdminTrackingData = useEnterpriseAdminTrackingData();

  return (
    <div>
      <div css={styles.innerWrapper}>
        <Icon color="interactive" css={styles.icon} size="large" />
        <div>
          <Typography2 component="h3" variant="subtitleMedium">
            {title}
          </Typography2>
          <Typography2 component="p" css={styles.descriptionText}>
            {description}
          </Typography2>
          <Link
            variant="quiet"
            typographyVariant="bodyPrimary"
            href={link}
            trackingData={{
              ...enterpriseAdminTrackingData,
              button: {
                name: trackingName,
              },
              pageSection: {
                sectionName: 'learner_insights',
                subsectionName: 'skill_development',
              },
            }}
            target="_blank"
            rel="noopener noreferrer"
          >
            {linkText}
          </Link>
        </div>
      </div>
      <Divider />
    </div>
  );
};

export default EmptyTrendingSkillsRow;
